import { Component, inject, OnInit } from '@angular/core';
import { SharedStorageService } from '../../shared/services/shared-storage.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ReserveConfirmReminderService } from '../../shared/services/reserve-confirm-reminder.service';
import { ExamItemName } from '../../shared/interfaces/reserve-confirm-survey.model';
import { ExamInfo } from '../../shared/interfaces/reserve-loading.model';
import { AddExamInfo } from '../../shared/interfaces/reserve-add.model';
import {
  CheckReminderRequest,
  Reminder,
} from '../../shared/interfaces/reserve-confirm-reminder.model';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { Router } from '@angular/router';
import { LOGIN_REGISTER_TABS } from '../../shared/constants/common.constants';
import { NgOptimizedImage } from '@angular/common';
import { AuthService } from '../../shared/services/auth.service';
import { MemberInfoResponse, ModifyInfoService } from '../../shared/services/modify-info.service';

/**
 * 檢查提醒組件
 */
@Component({
  selector: 'app-reserve-confirm-reminder',
  standalone: true,
  imports: [
    TranslatePipe,
    MatCheckbox,
    FormsModule,
    MatButton,
    NgOptimizedImage,
  ],
  templateUrl: './reserve-confirm-reminder.component.html',
  styleUrl: './reserve-confirm-reminder.component.scss',
})
export class ReserveConfirmReminderComponent implements OnInit {
  sharedStorageService: SharedStorageService = inject(SharedStorageService);
  translateService: TranslateService = inject(TranslateService);
  reserveConfirmReminderService: ReserveConfirmReminderService = inject(
    ReserveConfirmReminderService
  );
  router: Router = inject(Router);
  authService: AuthService = inject(AuthService);
  modifyInfoService: ModifyInfoService = inject(ModifyInfoService);

  // 檢查提醒清單
  reminderList: Array<Reminder> = [];

  // 是否勾選同意條款
  agreeChecked: boolean[] = [];

  ngOnInit(): void {

    // 解決髒資料問題，若是已登入狀態
    if (this.sharedStorageService.get('loginStatus') === 'memberLogin') {
      this.modifyInfoService.getMemberInfo().subscribe({
        next: (res: MemberInfoResponse) => {

          // 髒資料由 interceptor 處理
          if (res.statusCode === 'S0000') {
            console.log('token有效，資料保留');
          }
        }
      });
    }

    // 設置當前預約步驟為5
    setTimeout(() => {
      this.sharedStorageService.set('reserveStep', 5);
    });

    // 過濾出selectFlag為1的資料
    const examItemList = this.sharedStorageService.get('examItemList')?.filter((examInfo: ExamInfo) => examInfo.selectFlag === 1)?.map((examInfo: ExamInfo) => examInfo.examItem);
    console.log('examItemList', examItemList);
    const examItemNameList: Array<ExamItemName> =
      this.sharedStorageService.get('examItemList')?.map((examInfo: ExamInfo) => ({
          examItem: examInfo.examItem,
          examName: examInfo.examName,
          selectFlag: examInfo.selectFlag
        })) ?? [];
    const addExamItemNameList: Array<ExamItemName> =
      this.sharedStorageService
        .get('addExamItemList')?.filter((addExamInfo: AddExamInfo) => (addExamInfo.selectFlag ?? 0) === 1)
        ?.map((examItem: AddExamInfo) => ({
          examItem: examItem.examItem,
          examName: examItem.examName,
        })) ?? [];

    const request: CheckReminderRequest = {
      examItemList: examItemNameList,
      addList: addExamItemNameList,
    };
    // 查詢檢查提醒
    this.reserveConfirmReminderService
      .checkReminders(request)
      .subscribe(res => {
        if (res.data?.reminderList && res.data.reminderList.length > 0) {
          this.reminderList = res.data?.reminderList ?? [];

          this.agreeChecked = new Array(this.reminderList.length).fill(false);
        }
      });
  }

  // 取得提醒檢項標題
  getReminderExamTitle(reminder: Reminder): string {
    return reminder.examNameList
      ?.map(
        name =>
          name +
          this.translateService.instant('reserve-confirm-reminder.reminder')
      )
      .join('/');
  }

  allAgree() {
    return (
      this.agreeChecked.length > 0 &&
      this.agreeChecked.every(checked => checked)
    );
  }

  // 點擊"確認"
  confirm() {
    const loginStatus = this.sharedStorageService.get('loginStatus');
    const createMemberRequest = this.sharedStorageService.get('createMemberRequest');
    // 預約中登入 依照前面登入狀態來決定導向頁面
    if (loginStatus === 'memberLogin' && createMemberRequest?.idNo && this.authService.isLogin()) {
      const modifyType = this.sharedStorageService.get('modifyType');
      if(modifyType === 'modifyExam'){
        //來自會員中心調整檢項
        this.router.navigate(['/healthcheck/reserve/timeselect']).then();
      }else{
        this.router.navigate(['/healthcheck/reserve/bookinfo']).then();
      }
      
    } else if (loginStatus === 'newFriend' || loginStatus === undefined) {
      this.router
        .navigate(['/healthcheck/login'], {
          queryParams: { tab: LOGIN_REGISTER_TABS.REGISTER },
        })
        .then();
    } else if (loginStatus === 'withHIS' || loginStatus === 'withoutHIS') {
      this.router
        .navigate(['/healthcheck/contactinfo'], {
          queryParams: { backToAppointment: 'true' },
        })
        .then();
    }
  }
}
